import { useEffect, useState } from "react";
import { ReactComponent as InfoIcon } from "../../../assets/svg/icons/info.svg";
import { Loading } from "../../Loading/Index";
import InfoFailSync from "../../Tasks/ViewTasks/InfoFailSync";
import "./styles.css"
import { formatDateToCustomFormat } from "../../../utils/date/formatedDate";
import { ReactComponent as ArrowIcon } from "../../../assets/svg/icons/rightChevron.svg"
import { useTableMonitor } from "../../../hooks/useTableMonitor";

type FailSyncTableProps = {
  listTable: IFailSync[];
  isLoading: boolean;
};


export default function FailSyncTable({
  listTable,
  isLoading
}: FailSyncTableProps) {
  const [selectedId, setSelectedId] = useState(0);
  const { selectedOrder, setSelectedOrder, sortAsc, setSortAsc } = useTableMonitor();

  useEffect(() => {
    setSelectedOrder("createdAt")
  }, []);

  return (
    <>
      {listTable.length != 0 ?
        <>
          <section className="tableHeaderColumnFail">
            {[
              { key: "user", label: "Usuário" },
              { key: "createdAt", label: "Data" }
            ].map(({ label, key }) => (
              <div
                key={key}
                className="infoColumn"
                onClick={() => {
                  setSelectedOrder(key);
                  if (selectedOrder !== key) {
                    setSortAsc(false);
                    return;
                  }
                  setSortAsc(!sortAsc);
                }}
              >
                {label}
                <ArrowIcon
                  className={`iconSort${sortAsc ? "--asc" : ""}`}
                  style={{
                    display: selectedOrder === key ? "block" : "none",
                  }}
                />
              </div>
            ))}
            <div />
          </section>

          <section
            className="tableViewRows"
            style={{
              position: "relative",
            }}
          >
            <Loading visible={isLoading} />

            {listTable.map(rowData => {
              const date = new Date(rowData.date);

              return (
                <div className="tableRow">
                  <div>
                    {rowData.name}
                  </div>
                  <div>
                    {date ? formatDateToCustomFormat(date) : ""}
                  </div>
                  <div style={{
                    cursor: "pointer",
                  }}>
                    <InfoIcon
                      onClick={() => {
                        setSelectedId(rowData.id)
                      }}
                    />
                  </div>
                </div>
              )
            }
            )}
          </section>
        </>
        :
        <div className="emptyTable_container">
          <span>Nenhum resultado encontrado.</span>
        </div>
      }
      <InfoFailSync
        selected={selectedId}
        setSelectedId={setSelectedId}
      />
    </>
  );
}